export default __webpack_public_path__ + "img/sagoo/sagoo11_480.webp";